import * as qs from "querystringify"

import { DefaultPeriod, FixedPeriod } from "modules/HRAccount/PeriodsDropdown/PeriodsDropdown"
import { nonNullable } from "utils/nonNullable"

export function toQueryString(period: DefaultPeriod | FixedPeriod) {
    const o = Object.fromEntries(
        [
            "year" in period ? ["year", period.year] : undefined,
            "start" in period ? ["month_from", period.start + 1] : undefined,
            "end" in period ? ["month_to", period.end ? period.end + 1 : null] : undefined,
        ].filter(nonNullable)
    ) as Record<"year" | "start" | "end", number>
    return qs.stringify(o, "?")
}
